import {
    Mesh,
    DoubleSide,
    MeshBasicMaterial,
} from 'three';

import * as Chess from '../../libs/chess.js';
import '@chrisoakman/chessboardjs/dist/chessboard-1.0.0.css';
import '@chrisoakman/chessboardjs/dist/chessboard-1.0.0.js';
import $ from 'jquery';

import VRGameObject from './VRGameObject.js';
import { textureLoader, chessTexture, chessGeometry, btnGeometry, emptySeatTexture, ai_avatar, squareGeometry } from './helpers/texturesAndGeometries';
import { GAME_EVENTS, USER_CLICKED_GAME_EVENT } from '../../constants/game.js';
import { v4 as uuidv4 } from 'uuid';
import PlayerChessIndicator from './PlayerChessIndicator.js';

import { chess_game_dark } from '../components.js';
import ModalHandler from './helpers/ModalHandler.js.js';
import { SOCKET_EVENTS } from '../../socket/Events.js';
import RealPlayerChessIndicator from './RealPlayerChessIndicator.js';
import { GLOBAL_EVENTS } from '../../constants/global.js';
import { ICON } from '../Icons/Icons.js';
import { SCENE_EVENTS } from '../MVC/Model.js';
import gsap from 'gsap';
import ChessHistory from '../Chess/ChessHistory.js';
import { SCENE_INTERACTION } from '../../constants/scene.js';
import VolumeAnalyser from "../Controllers/AudioAnalyser/VolumeAnalyser";
import { getMoveHistory } from '../MVC/chessHelper';
import { ThreeDotsInviteTourItems } from '../Peoples/Peoples-UI.js';
import { requestMediaPermissions } from './helpers/userMediaHelper';
import { FEATURE_NAMES } from "../MVC/rolesHelper";

const aiProfile = {
    userId: 'na',
    userName: 'AI',
    userAvatarUrl: './textures/AI_avatar.png'
}

export default class VRChessObject extends VRGameObject {

    constructor(containerName, camera, texture, x, y, z, model) {

        super(containerName, model);

        const id = uuidv4();
        this.gameUniqueId = `chess-game-container_${id}`;

        const gameTemplate = $(chess_game_dark(id, multiLanguagesController.languageObject));
        const chessGameModals = $("#chess-game-modals");
        chessGameModals.append(gameTemplate);

        this.gameInstance = gameTemplate.find(`#chess-game-container_${id}`);
        this.gameModal = $(gameTemplate[0]);
        // this.chessVisitorsStats = $(`#chess-visitors-stats_${id}`);
        this.chessRestartBtn = this.gameModal.find(`.chess-restart_${id}`);
        this.winnerModal = chessGameModals.find(`#modal-winner_${id}`);
        this.winnerMsg = this.winnerModal.find(`#winner-msg_${id}`);
        this.winnerImage = this.winnerModal.find(`#winner-image_${id}`);
        this.chessVisitorsAvatars = this.gameModal.find(`#chess-visitors-avatars_${id}`);
        this.chessVisitorsNumber = this.gameModal.find(`#chess-visitors-number_${id}`);
        this.chessButtonsToggle = this.gameModal.find(`#toggleChessButtons_${id}`);
        this.toggleVisitorsVisibility = $(`#chess-toggle-visitors-visibility_${id}`);
        this.visitorsContainer = gameTemplate.find(`#chess-visitors-container_${id}`);
        this.playerOneContainer = this.gameModal.find(`#chess-player-one_${id}`);
        this.playerTwoContainer = this.gameModal.find(`#chess-player-two_${id}`);
        this.playerOneImg = this.playerOneContainer.find(`.chess-avatar-wrapper > img`);
        this.playerTwoImg = this.playerTwoContainer.find(`.chess-avatar-wrapper > img`);

        this.chessVideoButton = this.gameModal.find("#chess-toggleVideoTrack");
        this.chessAudioButton = this.gameModal.find("#chess-toggleAudioTrack");
        this.chessLockButton = this.gameModal.find("#chess-lock");
        this.chessRestartButton = $("#chess-restart");
        this.winnerModalRestartButton = $(`#winner-modal-restart_${id}`)
        this.closeWinnerModal = $(`#close-winner-modal_${id}`);

        this.winnerModalRestartButton.on('click', () => {
            this.winnerModal.removeClass('is-active');
            this.chessRestartButton.trigger('click');
        })
        this.closeWinnerModal.on('click', () => {
            this.winnerModal.removeClass('is-active');
        });

        // Initialize board with proper sizing
        this.board = window.Chessboard(this.gameUniqueId, this.boardConfig);
        this.board.resize();

        // Force a second resize after a short delay to ensure proper sizing
        setTimeout(() => {
            if (this.board) {
                this.board.resize();
            }
        }, 200);

        let resizeTimeout;
        let lastWidth = window.innerWidth;
        let lastHeight = window.innerHeight;

        const triggerResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                if (this.board) this.board.resize();
            }, 100);
        };

        $(window).on('resize', triggerResize);
        window.addEventListener('orientationchange', () => {
            setTimeout(triggerResize, 300);
        });
        this.game = null;
        // this.gameType = null;
        this.waitingForOpponent = false;
        this.checkTimer = null;
        this.whiteSquareGrey = '#96cc31'; //'#757575';
        this.blackSquareGrey = '#80ae2a'; //'#696969';
        this.squareClass = 'square-55d63';
        this.squareToHighlight = null;
        this.userVideo = $(`#chess-player-video`);

        this.player1 = { color: 'w', profile: null }
        this.player2 = { color: 'b', profile: null }

        this.camera = camera;
        this.material = new MeshBasicMaterial({ map: texture, side: DoubleSide, transparent: true });
        this.chessHistory = new ChessHistory(this.gameModal);

        this.mesh = new Mesh(this.model.editMode ? squareGeometry : chessGeometry, this.material);
        this.mesh.type = 'chessGame';
        this.mesh.name = 'chessGame';
        this.name = 'chessGame';
        const modalHandler = new ModalHandler(`#chess-game_${id}`);
        this.gameModal.on('click', () => {
            this.chessHistory.hide();
        });
        this.boardConfig = {
            orientation: 'white',
            position: 'start',
            draggable: true,
            moveSpeed: 'slow',
            snapbackSpeed: 500,
            // dropOffBoard: 'trash',
            snapSpeed: 100,
            onDragStart: this.onDragStart,
            onDrop: this.onDrop,
            onMoveEnd: this.onMoveEnd,
            onSnapEnd: this.onSnapEnd,
            onMouseoutSquare: this.onMouseoutSquare,
            onMouseoverSquare: this.onMouseoverSquare,
            sparePieces: false,
            showErrors: true,
        }

        this.gameData = {
            activeGame: false,
            from: '',
            to: '',
            fen: '',
            turn: 'w',
            player1: this.player1,
            player2: this.player2,
            isLocked: false,
            history: [],
        };

        // Initialize player indicators
        // this.playerOneIndicator = new RealPlayerChessIndicator(`chess-player-one_${id} #chess-avatar-wrapper-one`, ICON.HORSE_WHITE, "#chess-avatar-wrapper-one");
        const player1container = this.gameModal.find(`.chess-avatar-wrapper-one`)
        this.playerOneIndicator = new RealPlayerChessIndicator(player1container, ICON.HORSE_WHITE, "#chess-avatar-wrapper-one");
        this.playerOneIndicator.$textHolder.html($trans('take_this_seat_to_play_as_white'));
        this.playerOneIndicator.$textHolder.attr('data-lang', 'take_this_seat_to_play_as_white');
        const player2container = this.gameModal.find(`.chess-avatar-wrapper-two`)
        this.playerTwoIndicator = new RealPlayerChessIndicator(player2container, ICON.HORSE_BLACK, "#chess-avatar-wrapper-two");
        this.playerTwoIndicator.$textHolder.html($trans('take_this_seat_to_play_as_black'));
        this.playerTwoIndicator.$textHolder.attr('data-lang', 'take_this_seat_to_play_as_black');
        // Initialize visitor indicators
        this.visitorIndicators = {};
        for (let i = 1; i <= 6; i++) {
            const seatId = `player-indicator-visitor-${i}`;
            const cont = this.gameModal.find(`#${seatId}`)
            const indicator = new PlayerChessIndicator(cont, model);
            this.visitorIndicators[seatId] = indicator;
        }

        // INIT
        this.camera !== null ? this._setInitialPosRot() : this.setPosition(x, y, z);

        this.add(this.mesh);

        this.mesh.groupDetails = { title: $trans('chess-game'), icon: 'sports_esports', editTitle: $trans('edit-chess-game'), dataLang: 'edit-chess-game' }

        if (!this.model.editMode) {
            this.addElement('chessPlayer1', btnGeometry, emptySeatTexture, 'chessAvatar', -15, 27, 0);
            this.addElement('chessPlayer2', btnGeometry, emptySeatTexture, 'chessAvatar', 15, 27, 0);
        }

        this.limits.min = 290;
        this.limits.max = 310;

        this.model.editMode && this.editControls();

        this.addListeners();

        // Ensure board is properly initialized after a delay
        setTimeout(() => {
            if (this.board) {
                this.board.resize();
            }
        }, 100);

        this.debouncedGetVisitors = this.debounce(this.getVisitorsTakenSeats.bind(this), 300);
        this.model.addEventListener(GAME_EVENTS.NEW_PLAYER_VIDEO, this.debouncedGetVisitors);
        this.model.addEventListener(GAME_EVENTS.NEW_VISITOR_VIDEO, this.debouncedGetVisitors);


        return this;
    }

    updateGameDataHandler = (payload) => {
        // this will handle movements actions
        switch (payload.action) {
            case 'turn': this.turnHandler(payload); break;
            case 'end game': this.gameData === payload.gameData; this.activeGame = false; break;
            default: console.error(payload);
        }
        if (payload.history) {
            this.chessHistory.setMoves(payload.history);
        }
        this.checkIfGameIsLockedAndShowIcon();
    }

    turnHandler = (payload) => {
        if (this.game === null) return;
        // this will handle movements actions
        if (payload.userId !== this.userProperties.userId) {
            this.gameData = payload.gameData;
            this.checkIfGameIsLockedAndShowIcon();

            // console.log('condition passed', this.gameData)
            this.game.move({
                from: payload.gameData.from,
                to: payload.gameData.to,
                promotion: 'q' // NOTE: always promote to a queen for example simplicity
            });


            this.board.position(payload.gameData.fen);
            this.game.setTurn(payload.gameData.turn);

            const clr = this.game.turn() === 'b' ? 'black' : 'white';
            this.removeHighlights(clr);
            this.gameInstance.find('.square-' + payload.gameData.from).addClass(`highlight-${clr}`);
            this.gameInstance.find('.square-' + payload.gameData.to).addClass(`highlight-${clr}`);

            this.updateStatus();
        } else {
            // console.log("I'm the sender", payload);
        }
    }

    visitorsNumberBlink = () => {
        // if (this.visitorsBlinkTimer) {
        //     clearTimeout(this.visitorsBlinkTimer);
        //     this.visitorsBlinkTimer = null;
        // }

        // // this.chessVisitorsStats.addClass('blink');

        // this.visitorsBlinkTimer = setTimeout(() => {
        //     this.chessVisitorsStats.removeClass('blink');
        // }, 2000);
    }

    handleChessGame = () => {
        // todo: assign player1 and player2 data, check if empty 'seats' otherwise just watch the game
        this.activeGame ? $("#continue-play-holder").show() : $("#continue-play-holder").hide();
        // $(".chess-game-landing").addClass('is-active');
    }

    minimizeGame = () => {
        $(".chess-game").removeClass('is-active');
        this.minimized = true;
    }

    startVsComputer = () => {
        // this.gameType = 'vsComputer';
        this.me();
        this.chessPlayer1.material.map = this.model.userAvatarTexture;
        this.chessPlayer2.material.map = ai_avatar;
        this.player1.profile = this.model.config;
        this.player2.profile = aiProfile;
        this.chessPlayer1.visible = true;
        this.chessPlayer2.visible = true;
        this.playerOneImg.attr('src', this.player1.profile.userAvatarUrl);
        this.playerTwoImg.attr('src', aiProfile.userAvatarUrl);
    }

    joinMultiplayerLobby = () => {
        // Check if game is locked and user is not a player
        if (this.gameData.isLocked) {
            this.model.alert('error', $trans('chess-game-locked'));
            return;
        }
        if (this.minimized) {
            this.continuePlaying();
            return;
        }

        this.model.dispatchEvent({ type: SCENE_EVENTS.CREATE_CHESS_CHAT, data: { id: this.dbConfig.id } });

        this.chessRestartBtn.hide();
        this.playerOrientationCorrection();

        this.send({
            eventName: GAME_EVENTS.NEW_VISITOR,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            gameData: this.gameData,
            data: {
                userId: this.userProperties.userId,
                userName: this.userProperties.userName,
                userAvatarUrl: this.userProperties.userAvatarUrl,
                wpId: this.userProperties.wpId || false
            }
        });
        this.model.showLoading();
        this.model.chessModeController.isPlayer = false;
        if (this.player1?.profile?.userId && this.player2?.profile?.userId && !this.minimized) {
            if (this.isPlayer()) {
                this.model.chessModeController.roomNameBox = this.dbConfig.id;
                this.model.chessModeController.connect().then(() => {
                    const videoPlayer = this.userVideo;
                    const container = this.gameModal.find('.chess-watchers');
                    container.append(videoPlayer);
                });
            }
        }
        this.model.showChessMenu();
        this.board.resize();
        setTimeout(() => {
            this.board.resize();
        }, 200);
    }

    playerOrientationCorrection = () => {
        if (this.board.orientation() === 'white') {

            this.playerOneContainer.addClass('bottom');

            this.playerTwoContainer.removeClass('bottom');
            this.playerTwoContainer.addClass('top');
        } else {
            this.playerTwoContainer.removeClass('top');
            this.playerTwoContainer.addClass('bottom');

            this.playerOneContainer.removeClass('bottom');
            this.playerOneContainer.addClass('top');
        }
    }

    gameStart = () => {
        this.activeGame = true;
        this.game = this.gameData.fen ? new Chess(this.gameData.fen) : new Chess();
        this.board = window.Chessboard(this.gameUniqueId, { ...this.boardConfig, position: this.gameData.fen || 'start' });
        this.game.setTurn(this.gameData.turn);
        this.playerOrientationCorrection();
        this.updateStatus();
        this.players[this.userProperties.userId] ? this.chessRestartBtn.show() : this.chessRestartBtn.hide();

        // Ensure board is properly sized
        setTimeout(() => {
            if (this.board) {
                this.board.resize();
            }
        }, 100);
    }

    startVsRealPlayer = () => {
        if (this.gameData.isLocked) {
            this.model.alert('error', "Game locked by another player");
            return;
        }
        this.model.hideLoading()
        // if(this.activeGame){
        if (this.game === null) {
            this.game = this.gameData.fen ? new Chess(this.gameData.fen) : new Chess();
        }

        this.board = window.Chessboard(this.gameUniqueId, { ...this.boardConfig, position: this.gameData.fen });
        this.game.setTurn(this.gameData.turn);

        // console.log('startvsrealplayer, fen used:', this.gameData)
        // }else{
        //     this.board.clear();
        //     if(!this.minimized){
        //         // console.log(this.player1, this.player2)
        //         this.playerOneContainer.toggleClass("chess-player-select", this.player1.profile === null);
        //         this.playerOneContainer.toggleClass("chess-player-info", this.player1.profile !== null);
        //         this.playerTwoContainer.toggleClass("chess-player-select", this.player2.profile === null);
        //         this.playerTwoContainer.toggleClass("chess-player-info", this.player2.profile !== null);
        //     }else{
        this.minimized = false;
        //     }

        //     this.playerOneImg.attr('src', this.player1.profile === null ? './textures/empty.png' : this.player1.profile.userAvatarUrl);
        //     this.playerTwoImg.attr('src', this.player2.profile === null ? './textures/empty.png' : this.player2.profile.userAvatarUrl);
        // }

        this.playerOrientationCorrection();

        // this.chessVisitorsStats.addClass('visible');
        // $(".chess-game-landing").removeClass('is-active');
        this.gameModal.addClass('is-active');
        this.board.resize();
        this.visitorsNumberBlink();
    }

    setPlayer = (player, clicked = false, force = false) => {
        clicked && (this.iAmPlayer = true);

        if (this.model.chessModeController.isPlayer && this.model.chessModeController.webRTCAdaptor && !force) {
            return;
        }
        this.gameModal.find(".chess-player-select").removeClass('chess-player-select');

        if (clicked) {
            this[player].color = player === 'player1' ? 'w' : 'b';
            this[player].profile = {
                userId: this.userProperties.userId,
                userName: this.userProperties.userName,
                userAvatarUrl: this.userProperties.userAvatarUrl,
                wpId: this.userProperties.wpId || false
            };
        }

        const isPlayer1 = player === "player1";
        const isPlayer2 = player === "player2";

        if (!clicked) {
            if (this.gameData?.player1?.profile) {
                const userData = this.model.socket.getUsersObject()[this.gameData.player1.profile.userId];
                if (!this.model.chessModeController.roomJoined) {
                    this.playerOneIndicator.showAvatar(this.player1.profile.userAvatarUrl, this.player1.profile.userId);
                    this.chessHistory.setWhitePlayer(this.player1.profile.userName);
                }
            }
            if (this.gameData?.player2?.profile) {
                const userData = this.model.socket.getUsersObject()[this.gameData.player2.profile.userId];
                if (!this.model.chessModeController.roomJoined) {
                    this.playerTwoIndicator.showAvatar(this.player2.profile.userAvatarUrl, this.player2.profile.userId);
                    this.chessHistory.setBlackPlayer(this.player2.profile.userName);
                }
            }
        }

        clicked && this.send({
            eventName: GAME_EVENTS.NEW_PLAYER,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            status: player,
            playerData: this[player],
            seatId: player,
            userStatus: "player",
        });

        if (isPlayer1 && clicked) {
            this.model.chessModeController.isPlayer = true;
            this.model.chessModeController.roomNameBox = this.dbConfig.id;
            if (this.model.chessModeController.webRTCAdaptor && this.model.chessModeController.roomJoined) {
                const videoPlayer = this.userVideo;
                if (videoPlayer.length) {
                    this.playerOneIndicator.showVideo(videoPlayer);
                    this.playerOneIndicator.setName(this.userProperties.userName);
                    this.setVolumeAnalyzer(videoPlayer, this.playerOneIndicator, this.userProperties.userId)
                } else {
                    console.error("Could not find #chess-player-video element");
                }
            }
            if (!this.model.chessModeController.roomJoined && this.model.chessModeController.webRTCAdaptor) {
                this.model.chessModeController.joinRoom();
                const videoPlayer = this.userVideo;
                if (videoPlayer.length) {
                    this.playerOneIndicator.showVideo(videoPlayer);
                    this.playerOneIndicator.setName(this.userProperties.userName);
                    this.setVolumeAnalyzer(videoPlayer, this.playerOneIndicator, this.userProperties.userId)
                } else {
                    console.error("Could not find #chess-player-video element");
                }
            }
            else if (!this.model.chessModeController.roomJoined && !this.model.chessModeController.webRTCAdaptor) {
                this.model.chessModeController.connect().then(() => {
                    const videoPlayer = this.userVideo;
                    if (videoPlayer.length) {
                        this.playerOneIndicator.showVideo(videoPlayer);
                        this.playerOneIndicator.setName(this.userProperties.userName);
                        this.setVolumeAnalyzer(videoPlayer, this.playerOneIndicator, this.userProperties.userId)
                    } else {
                        console.error("Could not find #chess-player-video element");
                    }
                });
            }
        }
        if (isPlayer2 && clicked) {
            this.model.chessModeController.isPlayer = true;
            this.model.chessModeController.roomNameBox = this.dbConfig.id;
            if (this.model.chessModeController.webRTCAdaptor && this.model.chessModeController.roomJoined) {
                const videoPlayer = this.userVideo;
                if (videoPlayer.length) {
                    this.playerTwoIndicator.showVideo(videoPlayer);
                    this.playerTwoIndicator.setName(this.userProperties.userName);
                    this.setVolumeAnalyzer(videoPlayer, this.playerTwoIndicator, this.userProperties.userId)
                } else {
                    console.error("Could not find #chess-player-video element");
                }
            }
            if (!this.model.chessModeController.roomJoined && this.model.chessModeController.webRTCAdaptor) {
                this.model.chessModeController.joinRoom();
                const videoPlayer = this.userVideo;
                if (videoPlayer.length) {
                    this.playerTwoIndicator.showVideo(videoPlayer);
                    this.playerTwoIndicator.setName(this.userProperties.userName);
                    this.setVolumeAnalyzer(videoPlayer, this.playerTwoIndicator, this.userProperties.userId)
                } else {
                    console.error("Could not find #chess-player-video element");
                }
            }
            else if (!this.model.chessModeController.roomJoined && !this.model.chessModeController.webRTCAdaptor) {

                this.model.chessModeController.connect().then(() => {
                    const videoPlayer = this.userVideo;
                    if (videoPlayer.length) {
                        this.playerTwoIndicator.showVideo(videoPlayer);
                        this.playerTwoIndicator.setName(this.userProperties.userName);
                        this.setVolumeAnalyzer(videoPlayer, this.playerTwoIndicator, this.userProperties.userId)
                    } else {
                        console.error("Could not find #chess-player-video element");
                    }
                });
            }
        }

        if (isPlayer1 || isPlayer2) {
            this.model.dispatchEvent({ type: SCENE_EVENTS.SHOW_CHESS_PLAYER_MODE_MENU });
        }
        const videoElement = this.userVideo;
        const savedState = JSON.parse(localStorage.getItem('user_invert_camera_'));
        const isInverted = savedState && savedState.state;
        if (isInverted && videoElement) {
            videoElement.addClass('invert');
        } else if (videoElement) {
            videoElement.removeClass('invert');
        }
    }

    continuePlaying = () => {
        this.minimized = false;
        // $(".chess-game-landing").removeClass('is-active');
        this.gameModal.addClass('is-active');
        this.board.resize();
    }

    initGame = () => {
        if (this.gameData.isLocked) {
            this.model.alert('error', "Game locked by another player");
            return;
        }
        const playerColor = $("#chess-player-color").val();

        if (this.activeGame) {
            this.board.destroy();
            this.newGame(playerColor);

        } else {
            this.newGame(playerColor);
        }

        // $(".chess-game-landing").removeClass('is-active');
        this.gameModal.addClass('is-active');
        this.board.resize();
    }

    newGame = (playerColor) => {
        this.reset();
        this.boardConfig.position = 'start';
        this.game = new Chess();
        this.board = window.Chessboard(this.gameUniqueId, { ...this.boardConfig, orientation: playerColor });
        this.chessHistory.setMoves([]);
        this.activeGame = true;
        // (this.player2.color === 'w' && this.gameType === 'vsComputer') && setTimeout(this.makeRandomMove, 1250);
        this.playerOneContainer.toggleClass('active', this.player1.color === 'w');
        this.playerTwoContainer.toggleClass('active', this.player2.color === 'w');
        this.playerOneIndicator.hideTimeIcon();
        this.playerTwoIndicator.hideTimeIcon();
        if (this.playerOneContainer.hasClass('active')) {
            this.playerOneIndicator.showTimeIcon();
        }
        if (this.playerTwoContainer.hasClass('active')) {
            this.playerTwoIndicator.showTimeIcon();
        }
    }

    end = () => {
        this.material.map = chessTexture;
    }

    onDragStart = (source, piece, position, orientation) => {
        if (this.game === null) return false;
        // do not pick up pieces if the game is ove
        if (this.game.game_over()) return false;

        if (!this.activeGame) return false;
        if (this.player1.profile === null || this.player2.profile === null) return false;

        if (this.player1.profile.userId === this.userProperties.userId || this.player2.profile.userId === this.userProperties.userId) {
            if (this.player1.profile.userId === this.player2.profile.userId) {
                if ((this.game.turn() === 'w' && piece.search(/^b/) !== -1) ||
                    (this.game.turn() === 'b' && piece.search(/^w/) !== -1)) {
                    return false
                }
            } else {
                if (this.player1.profile.userId === this.userProperties.userId) {
                    if (piece.search(/^b/) !== -1) return false;
                }
                if (this.player2.profile.userId === this.userProperties.userId) {
                    if (piece.search(/^w/) !== -1) return false;
                }
            }

        } else {
            return false;
        }
    }

    onDrop = (source, target) => {
        if (this.game === null) return false;
        this.removeGreySquares();
        // see if the move is legal
        const move = this.game.move({
            from: source,
            to: target,
            promotion: 'q' // NOTE: always promote to a queen for example simplicity
        });

        // illegal move
        if (move === null) return 'snapback';

        const clr = this.game.turn() === 'b' ? 'black' : 'white';
        this.removeHighlights(clr);
        this.gameInstance.find('.square-' + source).addClass(`highlight-${clr}`);
        this.gameInstance.find('.square-' + target).addClass(`highlight-${clr}`);

        // this.gameType === 'vsComputer' && setTimeout(this.makeRandomMove, 250);

        this.send({
            eventName: GAME_EVENTS.UPDATE_GAME_DATA,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            data: { fen: this.game.fen(), from: source, to: target, turn: this.game.turn() },
            action: 'turn',
            history: this.game.history({ verbose: true })
        });

        this.updateStatus();
    }

    // update the board position after the piece snap
    // for castling, en passant, pawn promotion
    onSnapEnd = () => {
        this.board.position(this.game.fen());
    }

    updateStatus = (skipTest = false) => {
        if (this.game === null) return false;
        let status = '';

        let moveColor = $trans('chess-white');
        const turn = this.game.turn();

        if (turn === 'b') {
            moveColor = $trans('chess-black');
        }

        this.playerOneContainer.toggleClass('active', this.player1.color === turn);
        this.playerTwoContainer.toggleClass('active', this.player2.color === turn);

        this.playerOneIndicator.hideTimeIcon();
        this.playerTwoIndicator.hideTimeIcon();
        if (this.playerOneContainer.hasClass('active')) {
            this.playerOneIndicator.showTimeIcon();
        }
        if (this.playerTwoContainer.hasClass('active')) {
            this.playerTwoIndicator.showTimeIcon();
        }

        const moves = this.game.history({ verbose: true })

        if (moves.length) {
            const lastMove = moves[moves.length - 1];
            let validPlayerNotification = false;
            let msg = '';

            if (this.player1?.profile?.userId === this.userProperties.userId && this.player1?.color === turn && this.minimized) {
                msg = `${this.player2.profile.userName} ${$trans('chess-made-a-move')} ( ${lastMove.from} ${$trans('chess-to')} ${lastMove.to} ) ${$trans('chess-in-your-chessgame')}`;
                validPlayerNotification = true;
            }

            if (this.player2?.profile?.userId === this.userProperties.userId && this.player2?.color === turn && this.minimized) {
                msg = `${this.player1.profile.userName} ${$trans('chess-made-a-move')} ( ${lastMove.from} ${$trans('chess-to')} ${lastMove.to} ) ${$trans('chess-in-your-chessgame')}`;
                validPlayerNotification = true;
            }

            validPlayerNotification && this.model.confirm(msg, () => { this.continuePlaying() }, { withSound: true, confirmBtnTxt: $trans('open-game-text'), cancelBtnTxt: 'OK' });
        }

        const area = this.player1.color === turn ? 'bottom right' : 'top right';

        // checkmate?
        if (!skipTest && this.game.in_checkmate()) {
            this.handleCheckMate(turn, moveColor);
        }

        // draw?
        else if (!skipTest && this.game.in_draw()) {
            if (!this.testIfUserIsPlayer()) {
                return;
            }
            this.reset();
            // this.restartGame();
            status = $trans('game-over-text') + $trans('drawn-position-text') + '!';
            this.playerOneContainer.addClass('draw');
            this.playerTwoContainer.addClass('draw');
            this.winnerModal.src = "./textures/draw.jpg";
            this.showWinner(status);
        }

        // game still on
        else {
            // check?
            if (this.game.in_check()) {
                status = `${moveColor} ${$trans('chess-in-check')}`;
                // need to add
                const targetSelector = turn === "w"
                    ? "#chess-avatar-wrapper-one .icon-container"
                    : "#chess-avatar-wrapper-two .icon-container";

                gsap.fromTo(targetSelector,
                    { boxShadow: "inset 0 0 0 0 red" },
                    {
                        boxShadow: "inset 0 0 60px 10px red",
                        duration: .25,
                        yoyo: true,
                        repeat: 9,
                        ease: "power1.inOut"
                    }
                );
                this.model.alert('error', status, { area });
            }
        }

    }

    handleCheckMate = (turn, moveColor) => {
        const playerName = turn === this.player1.color ? this.player2.profile.userName : this.player1.profile.userName;
        const user = this.model.socket.getUsersObject()[this.player1.profile.userId];
        const status = `${$trans('game-over-text')}, ${playerName} ${$trans('win-game-text')}! ${moveColor} ${$trans('chess-in-checkmate')}.`;
        this.playerOneContainer.toggleClass('checkmate', this.player1.color === turn);
        this.playerTwoContainer.toggleClass('checkmate', this.player2.color === turn);
        this.playerOneContainer.toggleClass('victory', this.player1.color !== turn);
        this.playerTwoContainer.toggleClass('victory', this.player2.color !== turn);
        this.winnerImage.src = "./textures/draw.jpg";
        this.showWinner(status);
    }

    makeRandomMove = () => {
        if (this.game.turn() === this.player2.color) {
            const possibleMoves = this.game.moves({ verbose: true });

            // game over
            if (possibleMoves.length === 0) {
                this.model.alert('neutral', $trans('no-more-moves'), { area: 'middle right' });
                // setTimeout(this.updateStatus, 1000);
                return;
            }

            const randomIdx = Math.floor(Math.random() * possibleMoves.length);
            const move = possibleMoves[randomIdx];
            this.game.move(move.san);

            // console.log(move)

            const clr = this.player2.color === 'b' ? 'black' : 'white';

            this.removeHighlights(clr);
            this.gameInstance.find('.square-' + move.from).addClass(`highlight-${clr}`);
            this.squareToHighlight = move.to;

            this.board.position(this.game.fen());
            setTimeout(this.updateStatus, 1000);
        }
    }

    removeHighlights = (color) => {
        this.gameInstance.find('.' + this.squareClass).removeClass('highlight-' + color);
    }

    onMoveEnd = () => {
        const clr = this.player2.color === 'b' ? 'black' : 'white';
        this.gameInstance.find('.square-' + this.squareToHighlight).addClass(`highlight-${clr}`);
    }

    greySquare = (square) => {
        const $square = this.gameInstance.find('.square-' + square);

        let background = $square.hasClass('black-3c85d') ? this.blackSquareGrey : this.whiteSquareGrey;

        $square.css('background', background);
    }

    removeGreySquares = () => {
        this.gameInstance.find('.square-55d63').css('background', '');
    }

    onMouseoverSquare = (square, piece) => {
        // get list of possible moves for this square

        if (this.game === null) return;

        const moves = this.game.moves({
            square: square,
            verbose: true
        });

        // exit if there are no moves available for this square
        if (moves.length === 0) return

        // highlight the square they moused over
        this.greySquare(square);

        // highlight the possible squares for this piece
        for (let i = 0; i < moves.length; i++) {
            this.greySquare(moves[i].to);
        }
    }

    onMouseoutSquare = (square, piece) => {
        this.removeGreySquares();
    }

    reset = () => {
        $(".chess-player").removeClass('check checkmate victory draw active');
        this.winnerModal.removeClass('is-active');
        this.removeHighlights('white');
        this.removeHighlights('black');
    }

    showWinner = (msg, avatarUrl) => {
        this.activeGame = false;
        this.winnerMsg.html(msg);
        this.winnerModal.addClass('is-active');
        this.winnerImage.attr('src', avatarUrl);
        this.send({
            eventName: GAME_EVENTS.UPDATE_GAME_DATA,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            data: { activeGame: false, fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR', from: '', to: '', turn: 'w' },
            action: 'end game'
        });
    }

    quitGame = () => {
        this.initGameData = false;
        $(".chess-game").removeClass('is-active');
        this.minimized = false;
        let userStatus = 'visitor';
        this.iAmPlayer = false;
        this.playerOneIndicator.clear();
        this.playerTwoIndicator.clear();

        if (this.player1.profile !== null) {
            if (this.player1.profile.userId === this.userProperties.userId) {
                userStatus = 'player';
                this.playerOneContainer.removeClass("active");
            }
        }

        if (this.player2.profile !== null) {
            if (this.player2.profile.userId === this.userProperties.userId) {
                userStatus = 'player';
                this.playerTwoContainer.removeClass("active");
            }
        }

        this.send({
            eventName: GAME_EVENTS.VISITOR_OR_PLAYER_LEFT,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            userStatus,
        });

        // Unlock game when a player leaves
        if (this.isPlayer()) {
            this.gameData.isLocked = false;
            this.send({
                eventName: GAME_EVENTS.CHESS_GAME_UNLOCKED,
                userId: this.userProperties.userId,
                gameId: this.dbConfig.id,
                gameData: this.gameData
            });
        }
        const videoPlayer = this.userVideo;
        const container = this.gameModal.find('.default-video-player-wrapper');
        container.append(videoPlayer);

        const $videoElement = $(videoPlayer);
        if ($videoElement.data('volumeAnalyser')) {
            const volumeAnalyzer = $videoElement.data('volumeAnalyser');
            volumeAnalyzer.destroy();
            this.model.removeAudioAnalyzer(volumeAnalyzer);
        }
        $videoElement.data('volumeAnalyser', null);
        $videoElement.data('pollingStarted', false);
    }

    quitGameOnly = () => {
        this.initGameData = false;
        this.minimized = false;
        this.send({
            eventName: GAME_EVENTS.VISITOR_OR_PLAYER_LEFT,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            userStatus: this.testIfUserIsPlayer() ? 'player' : 'visitor',
        });

        this.send({
            eventName: GAME_EVENTS.NEW_VISITOR,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            gameData: this.gameData,
            data: {
                userId: this.userProperties.userId,
                userName: this.userProperties.userName,
                userAvatarUrl: this.userProperties.userAvatarUrl,
            }
        });
        const videoPlayer = this.userVideo;
        const container = this.gameModal.find('.default-video-player-wrapper');
        container.append(videoPlayer);
        if (this.player1?.profile?.userId === this.userProperties.userId) {
            this.player1.profile = null;
            this.playerOneIndicator.showEmpty();
        }
        if (this.player2?.profile?.userId === this.userProperties.userId) {
            this.player2.profile = null;
            this.playerTwoIndicator.showEmpty();
        }
        if (this.player1.profile === null) {
            this.playerOneIndicator.showEmpty();
        } else {
            this.playerOneIndicator.showAvatar(this.player1.profile.userAvatarUrl, this.player1.profile.userId);
        }
        if (this.player2.profile === null) {
            this.playerTwoIndicator.showEmpty();
        } else {
            this.playerTwoIndicator.showAvatar(this.player2.profile.userAvatarUrl, this.player2.profile.userId);
        }
    }

    restartGame = () => {
        this.model.confirm($trans('restart-game-confirm'), () => {
            this.send({
                eventName: GAME_EVENTS.RESTART_GAME,
                userId: this.userProperties.userId,
                gameId: this.dbConfig.id,
                gameData: { from: '', to: '', fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR', lastActivePlayer: 0, turn: 'w' }
            });
        });
    }

    restartGameHandler = (payload) => {
        this.game = new Chess();
        this.chessHistory.setMoves([]);
        this.board.start();
        this.reset();
        this.activeGame = true;
        this.updateStatus(true);
    }

    setPlayerAvatar = (player) => {
        switch (player) {
            case 'player1':
                if (this.player1.profile !== null) {
                    this.playerOneIndicator.showAvatar(this.player1.profile.userAvatarUrl, this.player1.profile.userId);
                    this.playerOneIndicator.setTooltip(this.player1.profile.userName);
                    this.playerOneIndicator.setName(this.player1.profile.userName);
                    this.chessPlayer1.material.map = textureLoader.load(this.player1.profile.userAvatarUrl);
                    this.chessPlayer1.visible = true;
                    this.playerOneContainer.removeClass("chess-player-select").addClass("chess-player-info");
                } else {
                    this.playerOneIndicator.showEmpty();
                    this.playerOneContainer.removeClass("active");
                    this.playerOneIndicator.setTooltip('Take a seat');
                    this.playerOneIndicator.setName('');
                    this.chessPlayer1.material.map = emptySeatTexture;
                    this.chessPlayer1.visible = false;
                    this.playerOneContainer.addClass("chess-player-select").removeClass("chess-player-info");
                }
                break;
            case 'player2':
                if (this.player2.profile !== null) {
                    this.playerTwoIndicator.removeClass("active");
                    this.playerTwoIndicator.showAvatar(this.player2.profile.userAvatarUrl, this.player2.profile.userId);
                    this.playerTwoIndicator.setTooltip(this.player2.profile.userName);
                    this.playerTwoIndicator.setName(this.player2.profile.userName);
                    this.chessPlayer2.material.map = textureLoader.load(this.player2.profile.userAvatarUrl);
                    this.chessPlayer2.visible = true;
                    this.playerTwoContainer.removeClass("chess-player-select").addClass("chess-player-info");
                } else {
                    this.playerTwoIndicator.showEmpty();
                    this.playerTwoIndicator.removeClass("active");
                    this.playerTwoIndicator.setTooltip('Take a seat');
                    this.playerTwoIndicator.setName('');
                    this.chessPlayer2.material.map = emptySeatTexture;
                    this.chessPlayer2.visible = false;
                    this.playerTwoContainer.addClass("chess-player-select").removeClass("chess-player-info");
                }
                break;
            default: return false;
        }
    }

    getInitialGameDataHandler = (payload) => {
        this.board.resize();
        const videoElement = this.gameModal.find('#chess-player-video');
        if (videoElement.length) {
            if (this.model.view.deviceSettingsMenu.selected.userCameraInverted) {
                videoElement.addClass('invert');
            } else {
                videoElement.removeClass('invert');
            }
        }

        if (payload.gameId === this.dbConfig.id) {
            if (this.initGameData) return;
            this.takenSeats = payload.takenSeats;
            this.visitors = payload.visitors;
            this.players = payload.players;
            if (payload.gameData)
                if (payload.gameData) {
                    this.gameData = payload.gameData;
                    this.checkIfGameIsLockedAndShowIcon();
                    payload.gameData.hasOwnProperty('activeGame') && (this.activeGame = payload.gameData.activeGame);
                    if (payload?.gameData?.player1?.profile) {
                        this.player1 = payload.gameData.player1;
                        this.playerOneIndicator.setName(payload?.gameData?.player1.profile.userName);
                        const user = this.model.socket.getUsersObject()[payload?.gameData?.player1.profile.userId];
                        user?.userAvatarUrl && this.playerOneIndicator.showAvatar(user.userAvatarUrl, user.userId);
                        this.chessHistory.setWhitePlayer(payload?.gameData?.player1.profile.userName);
                    }
                    if (payload?.gameData?.player2?.profile) {
                        this.player2 = payload.gameData.player2;
                        const user = this.model.socket.getUsersObject()[payload?.gameData?.player2.profile.userId];
                        this.playerTwoIndicator.setName(payload?.gameData?.player2.profile.userName);
                        user?.userAvatarUrl && this.playerTwoIndicator.showAvatar(user.userAvatarUrl, user.userId);
                        this.chessHistory.setBlackPlayer(payload?.gameData?.player2.profile.userName);
                    }
                }
            this.initGameData = true;
        }
        if (payload?.gameData?.history) {
            this.chessHistory.setMoves(payload.gameData.history);
        }
        if (payload.takenSeats) {
            this.showCorrectVideo(payload);
        }
        this.setInitialGameLockedStatus(payload);

    }

    newVisitorHandler = (payload) => {
        if (payload.gameId === this.dbConfig.id) {
            const { userId: senderId, players, visitors, gameData, takenSeats } = payload;
            if (payload?.gameData?.player1?.profile === null) {
                payload.takenSeats.player1 = null;
                this.playerOneIndicator.showEmpty();
            }
            if (payload?.gameData?.player2?.profile === null) {
                payload.takenSeats.player2 = null;
                this.playerTwoIndicator.showEmpty();
            }
            if (senderId === this.userProperties.userId) {
                this.getInitialGameDataHandler(payload);
            }
            if (payload?.gameData?.player1?.profile === null) {
                payload.takenSeats.player1 = null;
                this.playerOneIndicator.showEmpty();
            }
            if (payload?.gameData?.player2?.profile === null) {
                payload.takenSeats.player2 = null;
                this.playerTwoIndicator.showEmpty();
            }
            if (this.senderId === senderId) {
                this.gameModal.removeClass('is-active');
                this.model.alert('error', "Game locked by another player");
                return;
            }

            // console.log(players,gameData)

            this.players = players;
            this.visitors = visitors;
            this.gameData = gameData;

            if (senderId === this.userProperties.userId && gameData) {
                gameData.hasOwnProperty('activeGame') && (this.activeGame = gameData.activeGame);
                gameData.hasOwnProperty('player1') && (this.player1 = gameData.player1);
                gameData.hasOwnProperty('player2') && (this.player2 = gameData.player2);
                this.startVsRealPlayer();
            }


            this.createVisitorsAvatars();
        }
    }

    newPlayerHandler = (payload) => {
        if (payload.gameId === this.dbConfig.id) {
            const { userId: senderId, players, visitors, gameData, takenSeats } = payload;
            this.gameData = gameData;
            const user = this.model.socket.getUsersObject()[senderId];

            if (payload?.gameData?.player1?.profile === null) {
                payload.takenSeats.player1 = null;
                this.playerOneIndicator.showEmpty();
            }
            if (payload?.gameData?.player2?.profile === null) {
                payload.takenSeats.player2 = null;
                this.playerTwoIndicator.showEmpty();
            }

            players && Object.keys(players).forEach(key => {
                const player = players[key];
                if (player.profile && player.color === 'w') {
                    this.player1 = player;
                }
                if (player.profile && player.color === 'b') {
                    this.player2 = player;
                }
            });

            gameData.hasOwnProperty('activeGame') && (this.activeGame = gameData.activeGame);
            if (gameData.hasOwnProperty('player1')) {
                this.player1 = gameData.player1;
                const videoElement = this.findVideoElement(senderId);
                if (videoElement && videoElement.length) {
                    this.setVideoToContainer(videoElement, "player1", senderId);
                }
                if (gameData.player1.profile === null) {
                    this.playerOneIndicator.showEmpty();
                }
            }
            if (gameData.hasOwnProperty('player2')) {
                const videoElement = this.findVideoElement(senderId);
                if (videoElement && videoElement.length) {
                    this.setVideoToContainer(videoElement, "player2", senderId);
                }
                if (gameData.player2.profile === null) {
                    this.playerTwoIndicator.showEmpty();
                }
            }
            if (gameData?.player1?.profile) {
                this.player1 = gameData.player1;
                this.setPlayer("player1", false);
            }
            if (gameData?.player2?.profile) {
                this.player2 = gameData.player2;
                this.setPlayer("player2", false);
            }
            this.resetPlayersIfNullData();

            if (senderId === this.userProperties.userId) {
                this.chessRestartBtn.show();
                // console.log('it is sender')
                if (this.player1.profile !== null && this.player2.profile !== null) {
                    this.send({
                        eventName: GAME_EVENTS.GAME_START,
                        userId: this.userProperties.userId,

                        gameId: this.dbConfig.id,
                        gameData: { 'activeGame': true }
                    });
                } else {
                    // console.log(this.player1, this.player2);
                }
            } else {
                // console.log('sender not match', this.userProperties, senderId);
            }

            this.players = players;
            this.visitors = visitors;
            this.createVisitorsAvatars();
            // Reset lock state for new game
            this.gameData.isLocked = false;

            this.debouncedGetVisitors();
        }
    }

    createVisitorsAvatars = () => {
        return;
        this.chessVisitorsAvatars.html("");
        let removeFromVisitorsCounter = 0;

        for (const key in this.visitors) {
            const { userId, userName, userAvatarUrl, status } = this.visitors[key];

            // This condition must run on server when new visitor joins and remove user from visitors if he is a player (also have to update game data when user is disconnected - check if user was a player)
            if (this.player1.profile !== null) {
                if (this.player1.profile.userId === userId) {
                    removeFromVisitorsCounter++;
                    continue;
                }
            }
            if (this.player2.profile !== null) {
                if (this.player2.profile.userId === userId) {
                    removeFromVisitorsCounter++;
                    continue;
                }
            }

            // create visitor avatar
            // this.chessVisitorsAvatars.append(`
            //     <div class="chess-visitor-avatar avatar_${userId}" data-id='${userId}'>
            //         <img src="${userAvatarUrl}" alt="${userName}" class="avatar_${userId} chess_avatar_${userId} ${userId}">
            //     </div>
            // `);
        }

        const visitorsLength = Object.keys(this.visitors).length - removeFromVisitorsCounter;
        this.chessVisitorsNumber.text(visitorsLength);

        this.visitorsNumberBlink();
    }

    gameStartHandler = (payload) => {
        if (payload.gameId === this.dbConfig.id) {
            const { userId: senderId, players, visitors, gameData, takenSeats } = payload;
            this.visitors = visitors;
            this.players = players;
            this.gameData = gameData;
            this.activeGame = this.gameData.activeGame;
            const userId = this.gameData?.player1?.profile?.userId;
            const user = this.model.socket.getUsersObject()[senderId];
            let videoElement;
            if (this.gameData?.player1?.profile) {
                videoElement = $(`#player-CHESS-PLAYER-${senderId}`);
                if (!videoElement.length) {
                    videoElement = $(`#player-CHESS-WATCHER-${senderId}`);
                }
                if (videoElement.length) {
                    this.setVideoToContainer(videoElement, "player1", senderId);
                }
                this.playerOneIndicator.setName(this.gameData?.player1?.profile?.userName);
            }
            if (this.gameData?.player2?.profile) {
                videoElement = $(`#player-CHESS-PLAYER-${userId}`);
                if (!videoElement.length) {
                    videoElement = $(`#player-CHESS-WATCHER-${senderId}`);
                }
                if (videoElement.length) {
                    this.setVideoToContainer(videoElement, "player2", senderId);
                }
                this.playerTwoIndicator.setName(this.gameData?.player2?.profile?.userName);
            }
            this.showCorrectVideo(payload);
            this.gameStart();
            this.checkIfGameIsLockedAndShowIcon();
        }
    }

    visitorPlayerLeftHandler = (payload) => {
        if (payload.gameId === this.dbConfig.id) {
            this.gameData = payload.gameData;
            this.takenSeats = payload.takenSeats;
            this.players = payload.players;
            this.visitors = payload.visitors;
            this.checkIfGameIsLockedAndShowIcon();
            this.visitorTakeSeatHandler(payload);
            const { userId, players, visitors, gameData, userStatus } = payload;

            if (userStatus) {
                this.gameData = gameData;

                if (gameData?.player1?.profile === null) {
                    this.playerOneIndicator.showEmpty();
                    this.gameData.player1 = null;
                }
                if (gameData?.player2?.profile === null) {
                    this.playerTwoIndicator.showEmpty();
                    this.gameData.player2 = null;
                }

                if (userStatus === 'visitor') {
                    for (const key in this.visitorIndicators) {
                        if (this.visitorIndicators[key].userId === userId) {
                            this.visitorIndicators[key].showEmpty();
                        }
                    }
                }

                if (userStatus === 'player') {
                    // todo: use concatenation inside a for loop for all players (on different games)
                    // console.log('user who left was a player', this.player1, this.player2, userId)
                    if (this.player1.profile !== null) {
                        if (this.player1.profile.userId == userId) {
                            // this.playerOneContainer.addClass("chess-player-select");
                            // this.playerOneContainer.removeClass("chess-player-info");
                            // this.player1.profile = null;

                            // this.playerOneImg.attr('src', `./textures/empty.png`);
                            // this.chessPlayer1.material.map = emptySeatTexture;
                            // this.chessPlayer1.visible = false;
                        }
                    }

                    if (this.player2.profile !== null) {
                        // if (this.player2.profile.userId == userId) {
                        //     this.playerTwoContainer.addClass("chess-player-select");
                        //     this.playerTwoContainer.removeClass("chess-player-info");
                        //     this.player2.profile = null;

                        //     this.playerTwoImg.attr('src', `./textures/empty.png`);
                        //     this.chessPlayer2.material.map = emptySeatTexture;
                        //     this.chessPlayer2.visible = false;
                        // }
                    }
                }
            }
            this.debouncedGetVisitors();
        }
    }

    resetPlayersIfNullData = () => {
        return;
        if (this.player1.profile === null) {
            this.playerOneContainer.addClass("chess-player-select");
            this.playerOneContainer.removeClass("chess-player-info");
            this.player1.profile = null;

            this.playerOneImg.attr('src', `./textures/empty.png`);
            this.chessPlayer1.material.map = emptySeatTexture;
            this.chessPlayer1.visible = false;

            // Clear player 1 name using setName
            this.playerOneIndicator.setName('');
        } else {
            this.playerOneContainer.removeClass("chess-player-select");
            this.playerOneContainer.addClass("chess-player-info");
        }

        if (this.player2.profile === null) {
            this.playerTwoContainer.addClass("chess-player-select");
            this.playerTwoContainer.removeClass("chess-player-info");
            this.player2.profile = null;

            this.playerTwoImg.attr('src', `./textures/empty.png`);
            this.chessPlayer2.material.map = emptySeatTexture;
            this.chessPlayer2.visible = false;

            // Clear player 2 name using setName
            this.playerTwoIndicator.setName('');
        } else {
            this.playerTwoContainer.removeClass("chess-player-select");
            this.playerTwoContainer.addClass("chess-player-info");
        }
    }

    flipBoard = () => {
        this.board.flip();
        // this.playerOneContainer.toggleClass('bottom');
        // this.playerOneContainer.toggleClass('top');
        // this.playerTwoContainer.toggleClass('bottom');
        // this.playerTwoContainer.toggleClass('top');

        false && this.send({
            eventName: 'GAME_RESET_SOCKET',
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            data: { activeGame: false, player1: { color: 'w', profile: null }, player2: { color: 'w', profile: null }, fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR', from: '', to: '', turn: 'w' }
        });
    }


    showInfo = (userId) => {
        const data = this.peerData(userId);
        $("#chess-info-avatar").attr('src', data.userAvatarUrl);
        $("#chess-info-name").text(data.userName);
        $("#chess-info-id").val(data.userId);

        $(".chess-info-cta").toggleClass("disabled", data.userId === this.userProperties.userId);

        $(".chess-info-modal").addClass("is-active");
    }

    chat = (userId) => {
        this.initiateChat(userId);
        $(".chess-info-modal").removeClass("is-active");
        this.minimizeGame();
    }

    videoCall = (userId) => {
        this.initiateVideoCall(userId);
        $(".chess-info-modal").removeClass("is-active");
        this.minimizeGame();
    }

    toggleChessButtons = () => {
        this.chessButtonsToggle.prop("checked", false);
    }

    visitorsStats = () => {
        this.toggleVisitorsVisibility.toggleClass('active');
        this.visitorsContainer.toggleClass('active');
    }
    lockGame = () => {
        if (this.testIfUserIsPlayer()) {
            this.gameData.isLocked = true;
            this.send({
                eventName: GAME_EVENTS.CHESS_GAME_LOCKED,
                userId: this.userProperties.userId,
                gameId: this.dbConfig.id,
                gameData: this.gameData
            });
        }
    }
    unlockGame = () => {
        if (this.testIfUserIsPlayer()) {
            this.gameData.isLocked = false;
            this.send({
                eventName: GAME_EVENTS.CHESS_GAME_UNLOCKED,
                userId: this.userProperties.userId,
                gameId: this.dbConfig.id,
                gameData: this.gameData
            });
        }
    }
    lockGameHandler = (payload) => {
        this.model.dispatchEvent({ type: GAME_EVENTS.CHESS_GAME_LOCKED, payload });
    }
    unlockGameHandler = (payload) => {
        this.model.dispatchEvent({ type: GAME_EVENTS.CHESS_GAME_UNLOCKED, payload })
    }
    showError = (payload) => {
        this.model.alert('error', payload.message, {
            area: 'middle'
        });
    }
    addListeners = () => {
        this.model.addEventListener(SCENE_EVENTS.START_ANIMTAION_OUTRO, (e) => {
            this.gameModal.hide();
        })
        // Ensure board is properly sized when modal is shown
        this.gameModal.on('shown.bs.modal', () => {
            if (this.board) {
                setTimeout(() => {
                    this.board.resize();
                }, 100);
            }
        });

        // Also resize when modal becomes visible
        this.gameModal.on('show', () => {
            if (this.board) {
                setTimeout(() => {
                    this.board.resize();
                }, 100);
            }
        });

        this.model.addEventListener(GAME_EVENTS.NEW_VISITOR_VIDEO, (e) => {
            this.debouncedGetVisitors();
        });

        this.model.addEventListener(GAME_EVENTS.NEW_PLAYER_VIDEO, (e) => {
            this.debouncedGetVisitors();
        });

        this.model.addEventListener(USER_CLICKED_GAME_EVENT.HISTORY, (e) => {
            if (this.gameModal.hasClass('is-active')) {
                this.chessHistory.show();
            }
        });

        this.model.addEventListener(USER_CLICKED_GAME_EVENT.LOCK, (e) => {
            if (this.gameModal.hasClass('is-active')) {
                this.lockGame();
            }
        });
        this.model.addEventListener(USER_CLICKED_GAME_EVENT.UNLOCK, (e) => {
            if (this.gameModal.hasClass('is-active')) {
                this.unlockGame();
            }
        });

        this.model.addEventListener(GAME_EVENTS.CHESS_GAME_LOCKED, (data) => {
            const { payload } = data;
            if (payload.gameId === this.dbConfig.id) {
                this.gameData.isLocked = true;
                this.checkIfGameIsLockedAndShowIcon();
                if (!this.isPlayer()) {
                    // this.model.alert('info', 'Game has been locked by a player');
                }
            }
        });

        this.model.addEventListener(GAME_EVENTS.CHESS_GAME_UNLOCKED, (data) => {
            const { payload } = data;
            if (payload.gameId === this.dbConfig.id) {
                this.gameData.isLocked = false;
                // this.model.alert('info', 'Game has been unlocked');
                this.checkIfGameIsLockedAndShowIcon();
            }
        });

        this.model.addEventListener(SCENE_EVENTS.USER_INVERTS_CAMERA, async (e) => {
            const videoElement = this.gameModal.find('#chess-player-video');
            if (videoElement.length) {
                if (this.model.view.deviceSettingsMenu.selected.userCameraInverted) {
                    videoElement.addClass('invert');
                } else {
                    videoElement.removeClass('invert');
                }
            }
        });
        // Add click event listeners for visitor indicators
        for (const seatId in this.visitorIndicators) {
            const indicator = this.visitorIndicators[seatId];

            this.gameModal.find(`#${seatId}`).on('click', async () => {
                if (this.takenSeats && this.takenSeats[seatId]) {
                    this.model.alert('info', 'This seat is already taken');
                    return;
                }
                if (!await this.model.validatePlanFeature(FEATURE_NAMES.CHESS_GAME)) {
                    if (window.openLoginModal) {
                        window.openLoginModal($trans('you-need-to-login-to-take-a-seat'));
                    }
                    return;
                }
                if (!(await requestMediaPermissions('all', this.model))) {
                    return
                }
                if (this.testIfUserIsPlayer()) {
                    this.model.confirm($trans('leave-game-and-take-seat-as-visitor-or-invite'), () => {
                        this.switchPlayerToVisitor();
                        this.model.chessModeController.isPlayer = false;
                        this.send({
                            eventName: GAME_EVENTS.VISITOR_TAKE_SEAT,
                            userId: this.userProperties.userId,
                            userName: this.userProperties.userName,
                            gameId: this.dbConfig.id,
                            seatId: seatId,
                        });
                        this.model.chessModeController.roomNameBox = this.dbConfig.id;
                        if (this.model.chessModeController.webRTCAdaptor && this.model.chessModeController.roomJoined) {
                            const videoPlayer = this.userVideo;
                            if (videoPlayer.length) {
                                this.visitorIndicators[seatId].showVideo(videoPlayer);
                            }
                        } else {
                            this.model.chessModeController.connect().then(() => {
                                this.model.chessModeController.joinRoom();
                                const videoPlayer = this.userVideo;
                                if (videoPlayer.length) {
                                    this.visitorIndicators[seatId].showVideo(videoPlayer);
                                }
                            });
                        }
                    }, { header: true, title: $trans('confirmation-text'), cancelBtnTxt: $trans('invite-text') }, () => {
                        const chessGame = this.model.isUserPlayingChess(this.model.config.userId);
                        this.model.view.chessInviteModal.show(chessGame);

                    });
                } else {
                    this.model.confirm("Take seat as visitor?", () => {
                        this.model.chessModeController.isPlayer = false;
                        this.send({
                            eventName: GAME_EVENTS.VISITOR_TAKE_SEAT,
                            userId: this.userProperties.userId,
                            userName: this.userProperties.userName,
                            gameId: this.dbConfig.id,
                            seatId: seatId,
                        });
                        this.model.chessModeController.roomNameBox = this.dbConfig.id;
                        if (this.model.chessModeController.webRTCAdaptor && this.model.chessModeController.roomJoined) {
                            const videoPlayer = this.userVideo;
                            if (videoPlayer.length) {
                                this.visitorIndicators[seatId].showVideo(videoPlayer);
                            }
                        } else {
                            this.model.chessModeController.connect().then(() => {
                                this.model.chessModeController.joinRoom();
                                const videoPlayer = this.userVideo;
                                if (videoPlayer.length) {
                                    this.visitorIndicators[seatId].showVideo(videoPlayer);
                                }
                            });
                        }
                    }, { header: true, title: $trans('confirmation-text') });
                }
            });
        }

        // Add click event for player one indicator
        this.playerOneContainer.on('click', async () => {
            if (this.gameData.isLocked) {
                this.model.alert('info', 'Game is locked');
                return;
            }
            if (this.gameData?.player1?.profile !== null) {
                this.model.alert('info', 'This seat is already taken');
                return;
            }
            if (!await this.model.validatePlanFeature(FEATURE_NAMES.CHESS_GAME)) {
                if (window.openLoginModal) {
                    window.openLoginModal($trans('you-need-to-login-to-take-a-seat'));
                }
                return;
            }
            if (!(await requestMediaPermissions('all', this.model))) {
                return
            }
            if (this.isPlayer()) {
                this.model.confirm($trans('switch-sides-or-invite'), () => {
                    this.switchPlayerSides('player1');
                }, { header: true, title: $trans('confirmation-text'), cancelBtnTxt: $trans('invite-text'), confirmBtnTxt: $trans('switch-sides-text') }, () => {
                    const chessGame = this.model.isUserPlayingChess(this.model.config.userId);
                    this.model.view.chessInviteModal.show(chessGame);
                });
                return;
            }

            this.model.confirm($trans('take-seat-as-player-white'), () => {
                this.setPlayer('player1', true);
            }, { header: true, title: $trans('confirmation-text') });
            if (window.baglessTrack) {
                window.baglessTrack(this.model.config, "User took a seat as player white")
            }

        });

        // Add click event for player two indicator
        this.playerTwoContainer.on('click', async () => {
            if (this.gameData.isLocked) {
                this.model.alert('info', 'Game is locked');
                return;
            }
            if (this.gameData?.player2?.profile !== null) {
                this.model.alert('info', 'This seat is already taken');
                return;
            }
            if (!await this.model.validatePlanFeature(FEATURE_NAMES.CHESS_GAME)) {
                if (window.openLoginModal) {
                    window.openLoginModal($trans('you-need-to-login-to-take-a-seat'));
                }
                return;
            }
            if (!(await requestMediaPermissions('all', this.model))) {
                return
            }
            if (this.isPlayer()) {
                this.model.confirm($trans('switch-sides-or-invite'), () => {
                    this.switchPlayerSides('player2');
                }, { header: true, title: $trans('confirmation-text'), cancelBtnTxt: $trans('invite-text'), confirmBtnTxt: $trans('switch-sides-text') }, () => {
                    const chessGame = this.model.isUserPlayingChess(this.model.config.userId);
                    this.model.view.chessInviteModal.show(chessGame);

                });
                return;
            }
            if (window.baglessTrack) {
                window.baglessTrack(this.model.config, "User took a seat as player white")
            }
            this.model.confirm($trans('take-seat-as-player-black'), () => {
                this.setPlayer('player2', true);
            }, { header: true, title: $trans('confirmation-text') });
        });

        const getPlayer = (userId) => {
            userId = String(userId)
            if (String(this.gameData.player1?.profile?.userId) === userId) {
                return {
                    player: this.player1,
                    indicator: this.playerOneIndicator,
                }
            } else if (String(this.gameData.player2?.profile?.userId) === userId) {
                return {
                    player: this.player2,
                    indicator: this.playerTwoIndicator,
                }
            } else {
                for (const key in this.visitors) {
                    if (String(this.visitors[key]?.userId) === userId) {
                        return {
                            player: this.visitors[key],
                            indicator: this.visitorIndicators[key],
                        }
                    }
                }
            }
            return {
                player: null,
                indicator: null,
            }
        }
        this.model.addEventListener(GAME_EVENTS.CHESS_CONTROLLER_ROOM_LEFT, () => {
            this.debouncedGetVisitors();
        })
        this.model.addEventListener(GAME_EVENTS.CHESS_CONTROLLER_CONNECTED, () => {
            this.debouncedGetVisitors();
        })
        this.model.addEventListener(SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED, (e) => {
            console.log('SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED', e);

            const { data } = e;

            const { player, indicator } = getPlayer(data.userId)
            if (!player?.profile || !indicator) {
                return
            }

            const userData = this.model.socket.getUsersObject()[player.profile.userId];
            if (userData?.userAudioMuted) {
                indicator.hideSpeakingIndicator()
            } else {
                indicator.showSpeakingIndicator()
            }
        })
    }

    isPlayer = () => {
        return this.gameData.player1?.profile?.userId === this.userProperties.userId ||
            this.gameData.player2?.profile?.userId === this.userProperties.userId;
    }
    visitorTakeSeatHandler = (payload) => {
        if (payload.gameId === this.dbConfig.id) {
            if (payload?.gameData?.player1?.profile === null) {
                payload.takenSeats.player1 = null;
            }
            if (payload?.gameData?.player2?.profile === null) {
                payload.takenSeats.player2 = null;
            }
            this.showCorrectVideo(payload);
            const { takenSeats, gameData, player1, player2, userId, seatId } = payload;
            this.gameData = gameData;
            if (userId === this.userProperties.userId) {
                player1 && this.setPlayer('player1', false);
                player2 && this.setPlayer('player2', false);
            }
            if (this.gameData.player1?.profile?.userId) {
                this.playerOneIndicator.setName(this.gameData.player1?.profile?.userName);
            }
            if (this.gameData.player2?.profile?.userId) {
                this.playerTwoIndicator.setName(this.gameData.player2?.profile?.userName);
            }
            const visitorIndicator = this.visitorIndicators[seatId];
            if (!visitorIndicator) {
                console.error('No visitor indicator found for seat:', seatId);
                return;
            }
        }
    }

    visitorLeaveSeatHandler = (payload) => {
        if (payload.gameId === this.dbConfig.id) {
            this.checkIfGameIsLockedAndShowIcon();
            if (payload.gameId === this.dbConfig.id) {
                const { takenSeats, gameData, player1, player2 } = payload;
                this.gameData = gameData;
                if (payload?.gameData?.player1?.profile === null) {
                    payload.takenSeats.player1 = null;
                }
                if (payload?.gameData?.player2?.profile === null) {
                    payload.takenSeats.player2 = null;
                }
                this.checkIfGameIsLockedAndShowIcon();
                if (takenSeats) {
                    for (const seatId in this.visitorIndicators) {
                        this.visitorIndicators[seatId].showEmpty();
                    }
                    for (const [seatId, userId] of Object.entries(takenSeats)) {
                        if (this.visitorIndicators[seatId]) {
                            const userData = this.model.socket.getUsersObject()[userId];
                            if (userData) {
                                if (userId !== this.userProperties.userId && userData.streamId) {
                                    const videoElement = $(`#player-${userData.streamId}`);
                                    if (videoElement.length) {
                                        this.visitorIndicators[seatId].showVideo(videoElement);
                                        this.setVolumeAnalyzer(videoElement, this.visitorIndicators[seatId], userId)
                                    } else if (userData.userAvatarUrl) {
                                        this.visitorIndicators[seatId].showAvatar(userData.userAvatarUrl, userId);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    setVolumeAnalyzer = (videoElement, playerIndicator, playerId) => {
        videoElement = $(videoElement);
        let volumeAnalyzer = videoElement.data('volumeAnalyser');
        const stream = videoElement[0].srcObject;

        if (!volumeAnalyzer) {
            if (!stream) {
                const callback = () => {
                    this.setVolumeAnalyzer(videoElement, playerIndicator, playerId)

                    videoElement.data('pollingStarted', false)
                }

                // Skip if the polling is started, so that this code only run once
                if (videoElement.data('pollingStarted')) return;

                videoElement.data('pollingStarted', true)

                const poll = () => {
                    if (videoElement[0].srcObject) {
                        callback(videoElement);
                    } else {
                        requestAnimationFrame(poll);
                    }
                };

                poll();

                return
            }

            volumeAnalyzer = this.model.getAudioAnalyzerByStreamId(stream.id);
        }

        const player = this.model.socket.getUsersObject()[playerId]
        if (!volumeAnalyzer) {
            if (!this.audioContext) {
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            }

            volumeAnalyzer = new VolumeAnalyser({
                stream,
                audioContext: this.audioContext,
                onSpeakingChanged: (speaking) => {
                    playerIndicator.setSpeakingIndicatorStatus(speaking)
                }
            })

            volumeAnalyzer.videoElement = videoElement;

            this.model.registerAudioAnalyzer(volumeAnalyzer);
        } else {
            volumeAnalyzer
                .setOnSpeakingChanged((speaking) => {
                    playerIndicator.setSpeakingIndicatorStatus(speaking)
                })
                .setEnabled(true)
        }
        videoElement.data('volumeAnalyser', volumeAnalyzer);
        if (player?.userAudioMuted) {
            playerIndicator.hideSpeakingIndicator()
        } else {
            playerIndicator.showSpeakingIndicator()
        }
    }
    switchPlayerToVisitor = () => {
        this.model.chessModeController.isPlayer = false;
        this.send({
            eventName: GAME_EVENTS.VISITOR_OR_PLAYER_LEFT,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            userStatus: "player",
        });
        if (this.player1.profile !== null) {
            if (this.player1.profile.userId === this.userProperties.userId) {
                this.playerOneContainer.removeClass("active");
                this.playerOneIndicator.showEmpty();
                this.player1.profile = null;
            }
        }

        if (this.player2.profile !== null) {
            if (this.player2.profile.userId === this.userProperties.userId) {
                this.playerTwoContainer.removeClass("active");
                this.playerTwoIndicator.showEmpty();
                this.player2.profile = null;
            }
        }

        this.model.dispatchEvent({ type: SCENE_EVENTS.SHOW_CHESS_SPECTATOR_MODE_MENU });
    }
    clearVisitorIndicators = () => {
        for (const seatId in this.visitorIndicators) {
            this.visitorIndicators[seatId].showEmpty();
        }
    }

    testIfUserIsPlayer = () => {
        if (this.model.chessModeController.isPlayer && this.model.chessModeController.roomJoined) {
            return true;
        }
        return false;
    }
    testIfUserIsVisitor = () => {
        if (!this.model.chessModeController.isPlayer && this.model.chessModeController.roomJoined) {
            return true;
        }
        return false;
    }
    showCorrectVideo = (payload) => {
        if (payload.gameId === this.dbConfig.id) {
            this.takenSeats = payload.takenSeats;
            this.applyIndicatorData(payload);

            if (!this.model.chessModeController.roomJoined) {
                this.showAvatars(payload.takenSeats);
                return;
            }
            let videoElement = null;
            const user = this.model.socket.getUsersObject()[payload.userId];
            Object.keys(payload.takenSeats).forEach(seatId => {
                if (seatId === "undefined") {
                    return;
                }
                const userId = payload.takenSeats[seatId];
                videoElement = $(`#player-CHESS-PLAYER-${userId}`);
                if (!videoElement.length) {
                    videoElement = $(`#player-CHESS-WATCHER-${userId}`);
                }
                if (videoElement.length) {
                    this.setVideoToContainer(videoElement, seatId, userId);
                }
                for (const seatId in this.visitorIndicators) {
                    if (!payload.takenSeats[seatId]) {
                        this.visitorIndicators[seatId].showEmpty();
                    }
                }
                if (seatId === "player1" && videoElement.length) {
                    this.playerOneIndicator.showVideo(videoElement);
                }
                if (seatId === "player2" && videoElement.length) {
                    this.playerTwoIndicator.showVideo(videoElement);
                }
            });
            if (payload?.gameData?.player1?.profile === null) {
                this.playerOneIndicator.showEmpty();
            }
            if (payload?.gameData?.player2?.profile === null) {
                this.playerTwoIndicator.showEmpty();
            }
            if (!videoElement && payload?.userStatus === "player1") {
                this.playerOneIndicator.showAvatar(user.userAvatarUrl, payload.userId);
                this.playerOneIndicator.setName(user.userName);
            }
            if (!videoElement && payload?.userStatus === "player2") {
                this.playerTwoIndicator.showAvatar(user.userAvatarUrl, payload.userId);
                this.playerTwoIndicator.setName(user.userName);
            }
            Object.keys(this.visitorIndicators).forEach(seatId => {
                if (!payload.takenSeats[seatId]) {
                    this.visitorIndicators[seatId].showEmpty();
                }
            });
            Object.keys(this.visitorIndicators).forEach(seatId => {
                if (payload.takenSeats[seatId] && payload.takenSeats[seatId] === this.model.config.userId) {
                    videoElement = this.gameModal.find('#chess-player-video');
                    if (videoElement.length) {
                        this.setVideoToContainer(videoElement, seatId, this.model.config.userId);
                    }
                }
            });
        }
    }
    setVideoToContainer = (videoElement, container, userId) => {
        switch (container) {
            case 'player1':
                this.playerOneIndicator.showVideo(videoElement);
                this.setVolumeAnalyzer(videoElement, this.playerOneIndicator, userId);
                break;
            case 'player2':
                this.playerTwoIndicator.showVideo(videoElement);
                this.setVolumeAnalyzer(videoElement, this.playerTwoIndicator, userId);
                break;
            case 'player-indicator-visitor-1':
                this.visitorIndicators[container].showVideo(videoElement);
                this.setVolumeAnalyzer(videoElement, this.visitorIndicators[container], userId);
                break;
            case 'player-indicator-visitor-2':
                this.visitorIndicators[container].showVideo(videoElement);
                this.setVolumeAnalyzer(videoElement, this.visitorIndicators[container], userId);
                break;
            case 'player-indicator-visitor-3':
                this.visitorIndicators[container].showVideo(videoElement);
                this.setVolumeAnalyzer(videoElement, this.visitorIndicators[container], userId);
                break;
            case 'player-indicator-visitor-4':
                this.visitorIndicators[container].showVideo(videoElement);
                this.setVolumeAnalyzer(videoElement, this.visitorIndicators[container], userId);
                break;
            case 'player-indicator-visitor-5':
                this.visitorIndicators[container].showVideo(videoElement);
                this.setVolumeAnalyzer(videoElement, this.visitorIndicators[container], userId);
                break;
            case 'player-indicator-visitor-6':
                this.visitorIndicators[container].showVideo(videoElement);
                this.setVolumeAnalyzer(videoElement, this.visitorIndicators[container], userId);
                break;

        }
    }
    showAvatars = (takenSeats) => {
        for (const seatId in this.visitorIndicators) {
            if (!takenSeats[seatId]) {
                this.visitorIndicators[seatId].showEmpty();
            } else {
                const userId = takenSeats[seatId];
                const user = this.model.socket.getUsersObject()[userId];
                if (user && user.userId !== this.userProperties.userId) {
                    this.visitorIndicators[seatId].showAvatar(user.userAvatarUrl, userId);
                }
            }
        }
        if (takenSeats["player1"]) {
            const user = this.model.socket.getUsersObject()[takenSeats["player1"]];
            if (user && user.userId !== this.userProperties.userId) {
                this.playerOneIndicator.showAvatar(user.userAvatarUrl);
                this.playerOneIndicator.setName(user.userName);
            }
        } else {
            this.playerOneIndicator.showEmpty();
        }
        if (takenSeats["player2"]) {
            const user = this.model.socket.getUsersObject()[takenSeats["player2"]];
            if (user && user.userId !== this.userProperties.userId) {
                this.playerTwoIndicator.showAvatar(user.userAvatarUrl);
                this.playerTwoIndicator.setName(user.userName);
            }
        } else {
            this.playerTwoIndicator.showEmpty();
        }
    }
    switchPlayerSides = (player) => {
        this.playerOneIndicator.clear();
        this.playerTwoIndicator.clear();
        this.send({
            eventName: GAME_EVENTS.VISITOR_OR_PLAYER_LEFT,
            userId: this.userProperties.userId,
            gameId: this.dbConfig.id,
            userStatus: player,
        });
        setTimeout(() => {
            this.setPlayer(player, true, true);
        }, 300);
    }
    findVideoElement = (userId) => {
        let videoElement = $(`#player-CHESS-PLAYER-${userId}`);
        if (videoElement.length) {
            return videoElement;
        }
        videoElement = $(`#player-CHESS-WATCHER-${userId}`);
        if (videoElement.length) {
            return videoElement;
        }
        return null;
    }
    checkIfGameIsLockedAndShowIcon = () => {
        if (this?.gameData?.isLocked) {
            const indicator = this.model.view.getIndicatorFromMeshId(this.dbConfig.id);
            if (indicator) {
                $(`.${indicator.element}`).find(".locked").show();
                this.indicator.removeClass("isPlaying");
                this.indicator.addClass("isLocked");
            }
        }
        if (!this?.gameData?.isLocked) {
            const indicator = this.model.view.getIndicatorFromMeshId(this.dbConfig.id);
            if (indicator) {
                $(`.${indicator.element}`).find(".locked").hide();
                this.indicator.removeClass("isLocked");
            }
        }
    }
    setInitialGameLockedStatus = (payload) => {
        if (payload?.gameData?.isLocked) {
            const indicator = this.model.view.getIndicatorFromMeshId(this.dbConfig.id);
            if (indicator) {
                $(`.${indicator.element}`).find(".locked").show();
                this.indicator.removeClass("isPlaying");
                this.indicator.addClass("isLocked");
            }
        }
        if (!payload?.gameData?.isLocked) {
            const indicator = this.model.view.getIndicatorFromMeshId(this.dbConfig.id);
            if (indicator) {
                $(`.${indicator.element}`).find(".locked").hide();
                this.indicator.removeClass("isLocked");
            }
        }
    }

    // Add debounce helper method
    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    getVisitorsTakenSeats() {
        this.send({
            eventName: GAME_EVENTS.GET_VISITORS_TAKEN_SEATS,
            userId: this.model.config.userId,
            gameId: this.dbConfig.id,
        });
    }
    setIndicator = (indicator) => {
        this.indicator = indicator;
        this.player1wrapper = indicator.find(".helper-icon.user-1");
        this.player2wrapper = indicator.find(".helper-icon.user-2");
        this.player1Image = indicator.find(".user-1 img");
        this.player2Image = indicator.find(".user-2 img");
        this.peoplesWrapper = indicator.find(".people-wrapper");
        this.peoplesWrapperCount = indicator.find(".people-wrapper-inner .world-bottom-nav__area__people__count");
        this.peoplesWrapper.hide();
    }
    applyIndicatorData = (payload) => {
        this.indicator.removeClass("isLocked");
        this.indicator.removeClass("isPlaying");
        const player1Count = payload.takenSeats.player1 ? 1 : 0;
        const player2Count = payload.takenSeats.player2 ? 1 : 0;
        const playersCount = player1Count + player2Count;
        const visitorsCount = Object.keys(payload.takenSeats)
            .filter((k) => k.startsWith("player-indicator-visitor-") && payload.takenSeats[k] !== null && payload.takenSeats[k] !== undefined)
            .length;
        const totalCount = playersCount + visitorsCount;
        this.peoplesWrapper.hide();
        this.player1wrapper.hide();
        this.player2wrapper.hide();
        this.peoplesWrapperCount.html(totalCount);

        if (totalCount === 0) {
            // everything stays hidden
        } else if (totalCount > 3) {
            this.peoplesWrapper.show();
            this.peoplesWrapperCount.text(totalCount);
        } else {
            if (player1Count > 0) {
                const user = this.model.socket.getUsersObject()[payload.takenSeats.player1];
                user?.userAvatarUrl && this.player1Image.attr("src", user.userAvatarUrl);
                this.player1wrapper.show();
            }
            if (player2Count > 0) {
                const user = this.model.socket.getUsersObject()[payload.takenSeats.player2];
                user?.userAvatarUrl && this.player2Image.attr("src", user.userAvatarUrl);
                this.player2wrapper.show();
            }
            if (playersCount === 0) {
                this.peoplesWrapper.show();
            }
        }
        if (player1Count > 0 && player2Count > 0) {
            this.indicator.addClass("isPlaying");
        }
        if (this.gameData.isLocked) {
            this.indicator.removeClass("isPlaying");
            this.indicator.addClass("isLocked");
        }
    }
}
